import getMetaData from '@core/api/oidcMeta';

const config = ({ authority, publicPath }) => ({
  authority,
  client_id: 'hub_ui',
  redirect_uri: `${window.location.origin}${publicPath}oidc-callback`,
  response_type: 'code',
  scope: 'openid profile Logix.Hub logix.auth logix.notify logix.api',
  post_logout_redirect_uri: `${window.location.origin}${publicPath}`,
  silent_redirect_uri: `${window.location.origin}${publicPath}silent-renew-oidc.html`,
  accessTokenExpiringNotificationTime: 10,
  automaticSilentRenew: true,
  automaticSilentSignin: false,
  filterProtocolClaims: true,
  loadUserInfo: true,
  metadata: getMetaData(authority),
});

export const authorityStorageKey = 'hub:authority';
export const settings = {
  authority: localStorage.getItem(authorityStorageKey), // this is set in the start.js
  publicPath: process.env.VUE_APP_PUBLIC_PATH,
};

export default () => config(settings);
